import PropTypes from "prop-types"

import { cn } from "styles/utils"

const Shimmer = ({ className, ...props }) => (
  <div
    className={cn(
      "animate-shimmer from-grey-200 via-grey-300 to-grey-200 overflow-hidden bg-gradient-to-r bg-[length:800px_100px] bg-[position:0_0]",
      className
    )}
    {...props}
  />
)

Shimmer.propTypes = {
  className: PropTypes.string,
}

export default Shimmer
